'use client';

import { useCallback,useEffect } from 'react';

type KeyboardOptions = {
  onEscape?: () => void;
  onTab?: (event: KeyboardEvent) => void;
  onEnter?: () => void;
  onArrowUp?: () => void;
  onArrowDown?: () => void;
}

export function useKeyboard(options: KeyboardOptions, isEnabled: boolean = true) {
  const handleKeyDown = useCallback(
    (event: KeyboardEvent) => {
      if (!isEnabled) return;

      switch (event.key) {
        case 'Escape':
          options.onEscape?.();
          break;
        case 'Tab':
          options.onTab?.(event);
          break;
        case 'Enter':
          options.onEnter?.();
          break;
        case 'ArrowUp':
          if (options.onArrowUp) {
            event.preventDefault();
            options.onArrowUp();
          }
          break;
        case 'ArrowDown':
          if (options.onArrowDown) {
            event.preventDefault();
            options.onArrowDown();
          }
          break;
      }
    },
    [isEnabled, options]
  );

  useEffect(() => {
    if (isEnabled) {
      document.addEventListener('keydown', handleKeyDown);
      return () => document.removeEventListener('keydown', handleKeyDown);
    }
  }, [isEnabled, handleKeyDown]);
}